import * as Sentry from '@sentry/react';

import { getGoneJobIdFromFailedRequest } from '~utils/jobs/getJobIdFromJobDetailsUrl';

// When a job stops being visible to the company while a user has it open (e.g. it's
// unassigned in another session), the API returns a 404 for every GET of the job or its
// details. That's expected rather than a client error, so those 404s aren't reported.
export function ignoreJob404Rule(event: Sentry.ErrorEvent) {
  const goneJobId = getGoneJobIdFromFailedRequest({
    method: event.request?.method,
    status: event.contexts?.response?.status_code,
    url: event.request?.url,
  });

  return Boolean(goneJobId);
}
